module.exports = __webpack_public_path__ + "static/media/logoAuth.86e5baf1.png";